import { useEffect } from 'react';

type BodyBackgroundProps = {
  color: string;
};

const BodyBackground = ({ color }: BodyBackgroundProps): null => {
  useEffect(() => {
    if (typeof document === 'undefined') {
      return undefined;
    }

    const bodyStyle = document.body.style;
    const previousColor = bodyStyle.getPropertyValue('--introwise-body-bg-color');

    bodyStyle.setProperty('--introwise-body-bg-color', color);

    return () => {
      if (previousColor) {
        bodyStyle.setProperty('--introwise-body-bg-color', previousColor);
      } else {
        bodyStyle.removeProperty('--introwise-body-bg-color');
      }
    };
  }, [color]);

  return null;
};

export default BodyBackground;
